import { ConnectionRecoveryPage } from 'src/features/connectivity';

export default function OfflineView() {
  return <ConnectionRecoveryPage />;
}
